import React from 'react';
import { useAuth } from '../../../context/AuthContext';

/**
 * Button row shared by every stack panel.
 *  - Demo   → bg-[#4D4D4D] (always available)
 *  - Actual → checks auth; opens SignUpModal if unauthenticated
 *  - Reset  → #3832e3 resets form
 *  - Cancel → optional, #3832e3 outline
 */
const PanelActions = ({
  onDemo,
  onActual,
  onReset,
  onCancel,
  openSignUp,
  loading = false,
  demoLabel = 'Demo',
  actualLabel = 'Actual',
}) => {
  const { isAuthenticated } = useAuth();

  const handleActual = () => {
    if (!isAuthenticated) {
      openSignUp?.();
      return;
    }
    onActual?.();
  };

  return (
    <div className="flex flex-col sm:flex-row justify-center gap-3 mt-4">
      <button
        onClick={onDemo}
        disabled={loading}
        className="w-full sm:w-auto px-6 py-2 font-mono text-xs uppercase tracking-[0.15em] font-medium bg-[#4D4D4D] text-white border border-[#4D4D4D] hover:bg-black transition-all disabled:opacity-50"
      >
        {demoLabel}
      </button>
      <button
        onClick={handleActual}
        disabled={loading}
        className="w-full sm:w-auto px-6 py-2 font-mono text-xs uppercase tracking-[0.15em] font-medium border border-zinc-300 text-black hover:border-[#4D4D4D] transition-all disabled:opacity-50"
      >
        {actualLabel}
      </button>
      <button
        onClick={onReset}
        className="w-full sm:w-auto px-6 py-2 font-mono text-xs uppercase tracking-[0.15em] font-medium bg-[#3832e3] text-white border border-[#3832e3] hover:bg-[#2a25b0] transition-all"
      >
        Reset
      </button>
      {onCancel && (
        <button
          onClick={onCancel}
          className="w-full sm:w-auto px-6 py-2 font-mono text-xs uppercase tracking-[0.15em] font-medium border border-[#3832e3] text-[#3832e3] hover:bg-[#3832e3]/5 transition-all"
        >
          Cancel
        </button>
      )}
    </div>
  );
};

export default PanelActions;
